//import i18n from "../app/i18n";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useTimeSince = () => {
  const { t } = useTranslation();

  const timeSince = useCallback(
    (date) => {
      if (typeof date !== "object") {
        date = new Date(date);
      }

      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);
      if (interval >= 1) {
        return t("time.year", { count: interval });
      } else {
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
          return t("time.month", { count: interval });
        } else {
          interval = Math.floor(seconds / 86400);
          if (interval >= 1) {
            return t("time.day", { count: interval });
          } else {
            interval = Math.floor(seconds / 3600);
            if (interval >= 1) {
              return t("time.hour", { count: interval });
            } else {
              interval = Math.floor(seconds / 60);
              if (interval >= 1) {
                return t("time.minute", { count: interval });
              } else {
                interval = seconds;
                return t("time.second", { count: interval });
              }
            }
          }
        }
      }
    },
    [t]
  );

  const dateFormatter = (s) => {
    var day,
      tz,
      rx = /^(\d{4}-\d\d-\d\d([tT ][\d:.]*)?)([zZ]|([+-])(\d\d):(\d\d))?$/,
      p = rx.exec(s) || [];
    if (p[1]) {
      day = p[1].split(/\D/);
      for (var i = 0, L = day.length; i < L; i++) {
        day[i] = parseInt(day[i], 10) || 0;
      }
      day[1] -= 1;
      day = new Date(Date.UTC.apply(Date, day));
      if (!day.getDate()) return new Date();
      if (p[5]) {
        tz = parseInt(p[5], 10) * 60;
        if (p[6]) tz += parseInt(p[6], 10);
        if (p[4] === "+") tz *= -1;
        if (tz) day.setUTCMinutes(day.getUTCMinutes() + tz);
      }
      return day;
    }
    return new Date();
  };

  return { timeSince, dateFormatter };
};
